import { Component } from '@angular/core';

@Component({
    selector: 'app-button-container',
    template: '<ng-content></ng-content>',
    styleUrls: ['./button-container.component.scss'],
    standalone: false
})
export class ButtonContainerComponent {}
